import { Injectable } from '@angular/core';

/** Session-backed store for the active context slug — safe for HTTP interceptors (no HttpClient). */
export const ACTIVE_CONTEXT_SLUG_KEY = 'activeContextSlug';

@Injectable({ providedIn: 'root' })
export class ContextSlugStore {
  get(): string | null {
    return sessionStorage.getItem(ACTIVE_CONTEXT_SLUG_KEY);
  }

  set(slug: string | null): void {
    if (slug) {
      sessionStorage.setItem(ACTIVE_CONTEXT_SLUG_KEY, slug);
    } else {
      sessionStorage.removeItem(ACTIVE_CONTEXT_SLUG_KEY);
    }
  }
}
